import { Component, OnDestroy, OnInit } from "@angular/core";
import { WindowService } from "@merri/common";
import { Subject } from "rxjs";
import { auditTime, take, takeUntil, tap } from "rxjs/operators";
import { PRODUCT_NAME } from "src/app/core";
import { Testimonial } from "../../testimonial";
import { TestimonialDisplayService } from "../../testimonial-display.service";

@Component({
    selector: "app-testimonial-display",
    templateUrl: "./testimonial-display.component.html",
    styleUrls: ["./testimonial-display.component.scss"],
    standalone: false
})
export class TestimonialDisplayComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void> = new Subject();
  private readonly breakpoint: number = 600;
  testimonials: Testimonial[];
  carouselConfig: { numItems: number; itemGap: number };

  readonly PRODUCT_NAME = PRODUCT_NAME;

  constructor(private testimonialDisplayService: TestimonialDisplayService, private windowService: WindowService) {}

  ngOnInit() {
    this.getTestimonials();
    this.setResizeSubscription();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private getTestimonials() {
    this.testimonialDisplayService
      .fetchLatest$()
      .pipe(take(1))
      .subscribe(testimonials => {
        this.testimonials = testimonials;
        this.setCarouselConfig();
      });
  }

  private getMediaQuery(): string {
    return this.windowService.getMediaQuery("max", this.breakpoint);
  }

  private setResizeSubscription() {
    this.windowService
      .getBreakpointObserver()
      .observe(this.getMediaQuery())
      .pipe(
        auditTime(20),
        tap(() => this.setCarouselConfig()),
        takeUntil(this.destroyed$),
      )
      .subscribe();
  }

  setCarouselConfig() {
    this.carouselConfig = this.windowService.matches(this.getMediaQuery()) ? { numItems: 1, itemGap: 0 } : { numItems: 0, itemGap: 12 };
  }
}
